interface V3IconEditProps extends React.SVGProps<SVGSVGElement> {
    stroke?: string;
}

export const V3IconEdit = ({ stroke = "#ABB0BA", ...rest }: V3IconEditProps) => <svg width="16" height="16" {...rest} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 14h3.131l8.22-8.22a2.214 2.214 0 1 0-3.13-3.131L2 10.869V14ZM9.438 3.432l3.131 3.131" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>
